import React from 'react';
import styled, { css } from 'styled-components';

import { Box, Flex, Paragraph } from '../UIKit/system';
import Title from '../title';
import mq from '../../utils/mq';
import RichTextField from '../rich-text-field';

const StyledItem = styled.div`
  margin-bottom: 48px;

  &:last-of-type {
    margin-bottom: 0;
  }
  ${mq.mobile(css`
    margin-bottom: 27px;
  `)};
`;

function Item({ title, text, secondText }) {
  return (
    <StyledItem>
      <Flex flexWrap={['wrap', 'unset', 'unset', 'unset']} gap={30}>
        <Box
          flexShrink={0}
          width={['100%', '20%', '30.5%']}
          mb={[25, 0, 0]}
        >
          <Title fontSizeSmall>{title}</Title>
        </Box>
        {typeof text == 'string' ? (
          <Paragraph fontSize={['14px', '16px', '16px']} html={text} flexGrow={secondText && 1} grey />
        ) : (
          <Paragraph fontSize={['14px', '16px', '16px']} flexGrow={secondText && 1} grey>
            <RichTextField data={text} />
          </Paragraph>
        )}
        {secondText && (
          <Paragraph fontSize={['14px', '16px', '16px']} grey>
            <RichTextField data={secondText} />
          </Paragraph>
        )}
      </Flex>
    </StyledItem>
  );
}

function TextContent({ items }) {
  return items.map((item, index) => {
    return <Item key={index} {...item} />;
  });
}

export default TextContent;
